import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./en";
import { fr } from "./fr";

const STORAGE_KEY = "shipyard.lang";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
] as const;
export type Language = (typeof LANGUAGES)[number]["code"];

const isLanguage = (value: string | null): value is Language => LANGUAGES.some((l) => l.code === value);

function initialLanguage(): string {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (isLanguage(saved)) return saved;
  } catch {
    // storage unavailable
  }
  return navigator.language.toLowerCase().startsWith("fr") ? "fr" : "en";
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr } },
  lng: initialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export function hasLanguageChoice(): boolean {
  try {
    return isLanguage(localStorage.getItem(STORAGE_KEY));
  } catch {
    return false;
  }
}

export function applyAccountLanguage(locale: string | null | undefined) {
  const lang = locale?.slice(0, 2) ?? null;
  if (!isLanguage(lang) || hasLanguageChoice() || i18n.language === lang) return;
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

export function setLanguage(lang: Language) {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // ignore
  }
}

document.documentElement.lang = i18n.language;

export default i18n;
